export * from './user-notification-dialog';

import { UserNotificationDialogComponent } from "./user-notification-dialog";

export const UserNotificationDialogOrganisms = [UserNotificationDialogComponent];